import { cva, type VariantProps } from "class-variance-authority";
import type { TwcComponentProps } from "react-twc";
import { twc } from "../utils";

export const widgetSubmitButtonVariants = cva(
  "cursor-pointer rounded-full font-semibold text-white transition-all active:scale-[0.98] focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      $variant: {
        default: "bg-checkbox-filled hover:bg-accent/80",
        secondary: "bg-accent hover:brightness-110",
      },
      $size: {
        default: "py-4 px-9 text-sm",
        sm: "py-3 px-5 text-sm",
      },
    },
    defaultVariants: {
      $variant: "default",
      $size: "default",
    },
  },
);

type WidgetSubmitButtonProps = TwcComponentProps<"button"> &
  VariantProps<typeof widgetSubmitButtonVariants>;

export const WidgetSubmitButton = twc.button<WidgetSubmitButtonProps>(({ $variant, $size }) =>
  widgetSubmitButtonVariants({ $variant, $size }),
);
